import React, { useEffect, useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import Navbar from '../components/Navbar';
import '../styles/styles.css';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import FooterGif from '../assets/videos/footer.gif';
import { FaHeart } from 'react-icons/fa';

function Contacto() {
  const form = useRef();
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    document.body.classList.add('body-contacto');
    return () => {
      document.body.classList.remove('body-contacto');
    };
  }, []);

  const enviarCorreo = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_v02jc5g', 'template_tztntqs', form.current, 'BtA1ijkqwoU7KGksJ')
      .then(() => {
        setModalVisible(true);
        form.current.reset();
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Hubo un error. Intenta de nuevo.');
      });
  };

  return (
    <>
      <Navbar />

      <section className="contacto-section">
        <video autoPlay loop muted playsInline className="contacto-video">
          <source src="/videos/contacto.mp4" type="video/mp4" />
        </video>

        <div className="contacto-box">
          <h1>Contáctame</h1>
          <p>Estoy lista para ayudarte en tu próximo proyecto.</p>

          <form ref={form} onSubmit={enviarCorreo} className="contacto-form">
            <input type="text" name="name" placeholder="Tu nombre" required />
            <input type="email" name="email" placeholder="Tu correo" required />
            <textarea name="message" placeholder="Tu mensaje" required />
            <button type="submit">Enviar mensaje</button>
          </form>
        </div>

        <footer className="footer-fixed-full">
          <div className="footer-container">
            <p className="footer-name">© {new Date().getFullYear()} Fabianna Julio</p>
            <div className="footer-icons">
              <a href="https://github.com/Missmuyanna" target="_blank" rel="noopener noreferrer" className="footer-icon"><FaGithub /></a>
              <a href="https://www.linkedin.com/in/fabianna-julio/" target="_blank" rel="noopener noreferrer" className="footer-icon"><FaLinkedin /></a>
              <a href="mailto:fabianna.julio12@email.com" className="footer-icon"><FaEnvelope /></a>
            </div>
          </div>
        </footer>
      </section>

      {/* Modal de confirmación */}
      {modalVisible && (
        <div className="modal-overlay" onClick={() => setModalVisible(false)}>
          <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
            <button className="modal-cerrar" onClick={() => setModalVisible(false)}>✖</button>
            <h3>¡Mensaje enviado con éxito!</h3>
            <img src={FooterGif} alt="Enviado" style={{ width: '100%', maxWidth: '300px', marginTop: '20px' }} />
            <p style={{ marginTop: '1rem' }}>
              Gracias por escribirme. Pronto te responderé <FaHeart color="red" style={{ marginLeft: '6px', verticalAlign: 'middle' }} />
            </p>

          </div>
        </div>
      )}
    </>
  );
}

export default Contacto;
